import React from 'react';
import { Flower, Facebook, Instagram, Youtube, Twitter, Mail, MapPin, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer id="footer" className="bg-[#3A5F7D] text-white pt-20 pb-10" data-id="element-106">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-107">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-108">
          {/* Brand Column */}
          <div className="space-y-6" data-id="element-109">
            <div className="flex items-center gap-2" data-id="element-110">
              <Flower className="h-8 w-8 text-[#D4AF37]" data-id="element-111" />
              <span className="font-serif text-2xl font-bold tracking-wide" data-id="element-112">
                Supradhyan
              </span>
            </div>
            <p className="text-gray-300 leading-relaxed" data-id="element-113">
              A sanctuary for spiritual growth, dedicated to spreading peace,
              harmony, and happiness through the ancient science of meditation.
            </p>
            <div className="flex gap-4" data-id="element-114">
              {[Facebook, Instagram, Youtube, Twitter].map((Icon, i) => <a key={i} href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#5B9BD5] hover:text-white transition-all duration-300" data-id="element-115">
                  <Icon className="w-5 h-5" data-id="element-116" />
                </a>)}
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-117">
            <h3 className="font-serif text-xl font-semibold mb-6 text-[#C5E0F4]" data-id="element-118">
              Quick Links
            </h3>
            <ul className="space-y-4" data-id="element-119">
              <li data-id="element-120">
                <Link to="/about" className="text-gray-300 hover:text-white transition-colors" data-id="element-121">
                  About The Center
                </Link>
              </li>
              <li data-id="element-122">
                <Link to="/courses" className="text-gray-300 hover:text-white transition-colors" data-id="element-123">
                  Upcoming Courses
                </Link>
              </li>
              <li data-id="element-124">
                <Link to="/satguru" className="text-gray-300 hover:text-white transition-colors" data-id="element-125">
                  Satguru Bio
                </Link>
              </li>
              <li data-id="element-126">
                <Link to="/volunteer" className="text-gray-300 hover:text-white transition-colors" data-id="element-127">
                  Volunteer
                </Link>
              </li>
              <li data-id="element-128">
                <Link to="/donate" className="text-gray-300 hover:text-white transition-colors" data-id="element-129">
                  Donate
                </Link>
              </li>
              <li data-id="element-130">
                <Link to="/faq" className="text-gray-300 hover:text-white transition-colors" data-id="element-131">
                  FAQ
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-132">
            <h3 className="font-serif text-xl font-semibold mb-6 text-[#C5E0F4]" data-id="element-133">
              Contact Us
            </h3>
            <ul className="space-y-6" data-id="element-134">
              <li className="flex items-start gap-3 text-gray-300" data-id="element-135">
                <MapPin className="w-5 h-5 text-[#5B9BD5] mt-1" data-id="element-136" />
                <span data-id="element-137">
                  108 Peace Valley Road,
                  <br data-id="element-138" />
                  Rishikesh, Uttarakhand,
                  <br data-id="element-139" />
                  India - 249201
                </span>
              </li>
              <li className="flex items-center gap-3 text-gray-300" data-id="element-140">
                <Phone className="w-5 h-5 text-[#5B9BD5]" data-id="element-141" />
                <span data-id="element-142">+91 98765 43210</span>
              </li>
              <li className="flex items-center gap-3 text-gray-300" data-id="element-143">
                <Mail className="w-5 h-5 text-[#5B9BD5]" data-id="element-144" />
                <span data-id="element-145">contact@supradhyan.org</span>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div data-id="element-146">
            <h3 className="font-serif text-xl font-semibold mb-6 text-[#C5E0F4]" data-id="element-147">
              Newsletter
            </h3>
            <p className="text-gray-300 mb-4" data-id="element-148">
              Subscribe to receive spiritual wisdom and course updates.
            </p>
            <form className="space-y-3" data-id="element-149">
              <input type="email" placeholder="Your email address" className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-3 text-white placeholder-gray-400 focus:outline-none focus:border-[#5B9BD5] transition-colors" data-id="element-150" />
              <button className="w-full bg-[#5B9BD5] hover:bg-[#7FB3E3] text-white font-medium py-3 rounded-lg transition-colors" data-id="element-151">
                Subscribe
              </button>
            </form>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-gray-400 text-sm" data-id="element-152">
          <p data-id="element-153">
            &copy; {new Date().getFullYear()} Supradhyan Enlightenment Center.
            All rights reserved.
          </p>
          <div className="flex gap-6" data-id="element-154">
            <a href="#" className="hover:text-white transition-colors" data-id="element-155">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-156">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}